import React, {Component} from 'react';
import {Link} from 'react-router';
import {Card} from 'antd';

import {queryIncCustomInfo} from '@api/incubator/custom';

import {BackBtn} from '@comm/BackBtn';
import CardBase from './CardBase';
import ComponentOut from './TableOut';
import CardAddress from './CardAddress';
import ComponentBill from '../../bill/ComponentBill';
import ComponentInvoice from '../../invoice/TableInvoice';
import ComponentContract from '../../contract/index/ComponentContract';

class PageDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customInfo: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getIncCustomInfo();
  }

  getIncCustomInfo = () => {
    queryIncCustomInfo({
      customUuid: this.props.params.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          customInfo: res.data,
        });
      }
    });
  };

  componentWillReceiveProps(nextProps) {}

  render() {
    const {
      params: { customUuid, incubatorUuid },
    } = this.props;
    const { customInfo } = this.state;
    const extra = <Link to={`/incubator/custom/base/${customUuid}`}>编辑资料</Link>;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <Card title={customInfo.customName} style={{ marginBottom: '16px' }} extra={extra}>
          <CardBase customInfo={customInfo} />
        </Card>
        <div />
        <ComponentBill
          pageSize={5}
          {...this.props}
          dimen="custom"
          dimenUuid={{ incubatorUuid, customUuid }}
        />
        <ComponentContract
          pageSize={5}
          {...this.props}
          dimen="custom"
          dimenUuid={{ incubatorUuid, customUuid }}
        />
        <CardAddress incubatorUuid={incubatorUuid} customUuid={customUuid} />
        <Card title="开票情况" style={{ marginBottom: '16px' }}>
          <ComponentInvoice customUuid={customUuid} incubatorUuid={incubatorUuid} pageSize={5} />
        </Card>
        <Card title="迁出情况" style={{ marginBottom: '16px' }}>
          <ComponentOut customInfo={customInfo} />
        </Card>
      </div>
    );
  }
}

export default PageDetail;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/detail/PageDetail.js